import { Termin } from '@/domain/arbeitszeiten/entities/Termin';
import { Arbeitsbereich } from './Arbeitsbereich';
import { Mitarbeiter } from './Mitarbeiter';
import { Rechtshinweis } from './Rechtshinweis';
import { Zeitstempel } from './Zeitstempel';
import { Zuschlag } from './Zuschlag';
import { BaseRow } from './BaseRow';
import { RowTypeKey } from './Entities';
import { Pause } from '@/domain/arbeitszeiten/entities';

type constructorParams = {
  mitarbeiter: Mitarbeiter;
  arbeitsbereich: Arbeitsbereich;
  beginn?: Zeitstempel;
  ende?: Zeitstempel;
  dauer?: number;
  kommen?: Zeitstempel;
  gehen?: Zeitstempel;
  rechtshinweise?: Rechtshinweis[];
  zuschlaege?: Zuschlag[];
  termin?: Termin;
  bemerkung?: string;
  pausen?: Pause[];
  id: string;
};

export class Arbeitszeit extends BaseRow {
  readonly _type: RowTypeKey = 'arbeitszeit';
  readonly mitarbeiter: Mitarbeiter;
  readonly arbeitsbereich: Arbeitsbereich;
  readonly beginn?: Zeitstempel;
  readonly ende?: Zeitstempel;
  readonly kommen?: Zeitstempel;
  readonly gehen?: Zeitstempel;
  readonly dauer?: number;
  readonly rechtshinweise: Rechtshinweis[];
  readonly zuschlaege: Zuschlag[];
  readonly termin?: Termin;
  readonly bemerkung?: string;
  readonly id: string;
  readonly pausen: Pause[];

  constructor({
    mitarbeiter,
    arbeitsbereich,
    beginn = null,
    ende = null,
    dauer = null,
    kommen = null,
    gehen = null,
    rechtshinweise = [],
    zuschlaege = [],
    termin = null,
    bemerkung = '',
    pausen = [],
    id,
  }: constructorParams) {
    super();
    this.mitarbeiter = mitarbeiter;
    this.arbeitsbereich = arbeitsbereich;
    this.beginn = beginn;
    this.ende = ende;
    this.dauer = dauer;
    this.kommen = kommen;
    this.gehen = gehen;
    this.rechtshinweise = rechtshinweise;
    this.zuschlaege = zuschlaege;
    this.termin = termin;
    this.bemerkung = bemerkung;
    this.id = id;
    this.pausen = pausen;
  }

  getPausendauer(): number {
    return this.pausen.reduce((total, pause) => total + pause.dauer, 0);
  }
}
